// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230004/js/" + chunkId + "." + {"44":"38c73750","225":"7d6f759f","481":"ed9ecab4","486":"f7594c16","770":"605c4e86"}[chunkId] + ".0.6891556551382864.chunk.js";
};